import {
  GET_ROLES_FAILED,
  GET_ROLES_REQUEST,
  GET_ROLES_SUCCESS,
} from './actionTypes';

const initialState = {
  loading: false,
  error: '',
  list: [],
  fetched: false,
};

const rolesSelectReducer = (state = initialState, {
  type, settings, error, roles,
}) => {
  switch (type) {
    case GET_ROLES_REQUEST:
      return {
        ...state,
        settings,
        loading: false,
      };
    case GET_ROLES_SUCCESS:
      return {
        ...state,
        list: roles.map((role) => ({ id: role.name, name: role.name.replace(/-/g, ' ') })),
        loading: false,
        fetched: true,
      };
    case GET_ROLES_FAILED:
      return {
        ...state,
        error,
        loading: true,
      };
    default:
      return state;
  }
};

export default rolesSelectReducer;
